export {
  invokeConfiguredAutomationWorkflow,
  type InvokeConfiguredAutomationWorkflowInput,
} from "../automation.js";
